<template>
  <b-modal
    id="error-modal"
    v-model="isVisible"
    centered
    hide-header
    hide-footer
  >
    <div class="error_wrapper">
      <img
        src="@/assets/icons/attention.svg"
        alt="Ícone de atenção"
        class="error_icon"
      />
      <p class="error_message">{{ message }}</p>
      <b-button id="error_back_btn" type="button" @click="close">
        Voltar
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  export default {
    name: "ErrorModal",
    computed: {
      message() {
        return this.$store.state.error_message;
      },
      isVisible: {
        get() {
          return this.$store.state.error_message !== "";
        },
        set(value) {
          if (!value) this.close();
        },
      },
    },
    methods: {
      close() {
        const redirect = this.$store.state.error_redirect;
        this.$store.commit("setErrorMessage", "");
        this.$store.commit("setErrorRedirect", "");
        if (redirect && this.$route.path !== redirect) {
          this.$router.push(redirect);
        }
      },
    },
  };
</script>

<style>
  #error-modal .modal-dialog {
    max-width: 400px;
    margin: 0 auto;
    padding: 16px;
  }
  #error-modal .modal-dialog-centered {
    min-height: 100%;
  }
  #error-modal .modal-content {
    border-radius: 20px;
    border: none;
  }
  #error-modal .modal-body {
    padding: 32px 24px 24px;
    max-height: 80vh;
    overflow-y: auto;
  }
  #error-modal .error_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
  }
  #error-modal .error_icon {
    width: 72px;
    height: 72px;
  }
  #error-modal .error_message {
    margin: 0;
    color: var(--dark-title);
    font-size: clamp(15px, 1.1vw, 18px);
    font-weight: normal;
    line-height: 1.4;
    text-align: center;
    overflow-wrap: break-word;
  }
  #error_back_btn {
    width: 100%;
    max-width: 300px;
    height: 45px;
    background-color: var(--red);
    border: none;
    color: var(--light);
    border-radius: 4px;
    font-size: clamp(16px, 1.1vw, 18px);
    font-weight: normal;
    transition: all 0.3s ease-in-out;
  }
  #error_back_btn:hover {
    opacity: 0.8;
    background-color: var(--red);
  }
  #error_back_btn:focus {
    outline: none;
    box-shadow: none;
    background-color: var(--red);
  }
</style>
